import { Booster, Contest } from 'models';

import {
  useGetParticipantBoostersQuery,
  useLazyGetParticipantBoostersQuery,
  useSetParticipantBoosterMutation,
} from 'api/contest';

import { selectSelectedBooster, setParticipation, setSelectedBooster } from 'store/slices/contest';

import { useAppDispatch, useAppSelector } from './app';

interface UseBoostersProps {
  contest: Contest | null;
}

const useBoosters = ({ contest }: UseBoostersProps) => {
  const [fetchBoosters, { data: boosters, isLoading: isBoostersLoading, isFetching: isBoostersFetching }] =
    useLazyGetParticipantBoostersQuery();
  const isLoading = isBoostersLoading;
  const filteredBoosters = boosters?.filter((booster) => !booster.usedAt) ?? [];

  const [setBoosterMutation, { isLoading: isSetBoosterLoading }] = useSetParticipantBoosterMutation();

  const dispatch = useAppDispatch();

  const setBooster = async (booster: Booster | null) => {
    if (isSetBoosterLoading) {
      return;
    }
    dispatch(setSelectedBooster(booster));
  };

  const selectedBooster = useAppSelector(selectSelectedBooster);

  const submitBooster = async ({ participantId }: { participantId: number }) => {
    if (isSetBoosterLoading || !selectedBooster) {
      return;
    }
    const { data, error } = await setBoosterMutation({
      participantId: participantId,
      boosterId: selectedBooster.id,
    });
    if (data) {
      dispatch(setParticipation(data));
    }
  };

  return {
    boosters: filteredBoosters,
    allBoosters: boosters,
    isLoading,
    isFetching: isBoostersFetching,
    setBooster,
    selectedBooster,
    submitBooster,
    fetchBoosters,
  };
};

export default useBoosters;
